import React, { DragEventHandler, FC, useCallback, useEffect, useMemo, useState } from 'react';
import { AnswerType1, AnswerType4, AnswerType6, AnswerType6Option, QuizQuestion } from '../../shared/types';
import { AutoResizableInput } from '../autoResizableInput/autoResizableInput';
import { shuffleAnswersType17 } from '../../shared/utils';
import quizPageStyles from '../../pages/quizPage/quizPage.module.scss';

type Props = {
  data: QuizQuestion;
  isSubmitted: boolean;
  answersState: string[];
  setAnswersState: (state: string[]) => void;
};

export const CardTemplate17: FC<Props> = ({ data, isSubmitted, answersState, setAnswersState }) => {
  const initData = data.paramjs as AnswerType6;
  const [variantsToChoose, setVariantsToChoose] = useState<string[]>([]);
  const [selectedAreaIndex, setSelectedAreaIndex] = useState(0);
  const splittedText = (data.paramjs as AnswerType6)?.text?.split('*');

  useEffect(() => {
    if (initData?.options) {
      const mixedValues = shuffleAnswersType17(initData?.options?.map((opt) => opt.value));
      setVariantsToChoose(mixedValues);
    }
  }, [initData]);

  return (
    <div className="text-center tw-px-3 xl:tw-px-[100px]">
      <h5 className="h3 tw-underline">{data.qs_main}</h5>
      <p className="tw-mt-3 tw-text-xl sm:tw-text-2xl">{data.qs_dsc}</p>
      {variantsToChoose.length > 0 && (
        <div className="btn-group tw-w-full mt-4 mt-sm-5 tw-flex tw-justify-center tw-flex-col tw-flex-wrap min-[400px]:tw-flex-row gap-3">
          {variantsToChoose?.map((variant) => {
            return (
              <div
                className={`rounded-1 py-1 px-3 tw-text-xl sm:tw-text-2xl mb-0 ${!isSubmitted ? 'tw-cursor-pointer' : ''} border border-1 border-gray bg-white tw-text-[#0c276c] hover:!tw-scale-[1.1] !tw-transition-all`}
                onClick={() => {
                  if (!isSubmitted) {
                    setAnswersState(answersState?.map((item, idx) => (idx === selectedAreaIndex ? variant : item)));
                    setSelectedAreaIndex(answersState.findIndex((item, idx) => !item && idx !== selectedAreaIndex));
                    setVariantsToChoose((prevState) => prevState.filter((item) => item !== variant));
                  }
                }}
              >
                {variant}
              </div>
            );
          })}
        </div>
      )}
      <div className="my-4 my-sm-5 tw-flex tw-justify-center tw-items-center tw-flex-wrap gap-2">
        {splittedText?.map((item, index) => (
          <>
            <p className="tw-text-xl sm:tw-text-2xl my-2">{item}</p>
            {index !== splittedText?.length - 1 && (
              <AutoResizableInput
                spellCheck={false}
                className={`${quizPageStyles.coloredInput} tw-h-[38px] text-center tw-text-xl sm:tw-text-2xl border border-1 border-gray tw-cursor-pointer focus-visible:tw-outline-[#0d6efd] ${!isSubmitted && selectedAreaIndex === index ? ' bg-primary-subtle' : ''} rounded-1 px-2 py-1 ${!isSubmitted ? 'hover:!tw-border-[#0c276c] tw-text-[#0c276c]' : initData?.options?.[index].value === answersState?.[index] ? ' !tw-bg-green-500 tw-text-black' : ' !tw-bg-red-500 !tw-text-white'}`}
                value={answersState?.[index]}
                onClick={() => {
                  if (!answersState?.[index] && !isSubmitted) {
                    setSelectedAreaIndex(index);
                  }
                }}
                readOnly
                clearable={!!answersState?.[index] && !isSubmitted}
                onClear={() => {
                  const set = new Set([...variantsToChoose, answersState?.[index]]);
                  // @ts-ignore
                  setVariantsToChoose([...set]);
                  setAnswersState(answersState?.map((answ, idx) => (index === idx ? '' : answ)));
                  setSelectedAreaIndex(index);
                }}
              />
            )}
          </>
        ))}
      </div>
    </div>
  );
};
